var map = {
	"./Azure.png": 9350,
	"./CSS.png": 8007,
	"./ChartJs.png": 3225,
	"./ElectronJS.png": 2783,
	"./Figma.png": 7936,
	"./Firebase.png": 4776,
	"./Flask.png": 6741,
	"./GCP.png": 8562,
	"./Git 2.png": 6851,
	"./Git.png": 9528,
	"./GitHub 2.png": 9992,
	"./GitHub.png": 5957,
	"./HTML.png": 4437,
	"./Heroku.png": 4294,
	"./HuggingFace.png": 6604,
	"./Java.png": 4788,
	"./JavaScript.png": 2801,
	"./Lua.png": 8058,
	"./Make.png": 9110,
	"./Matplotlib.png": 8530,
	"./MongoDB.png": 730,
	"./Mongoose.png": 9275,
	"./MySQL 2.png": 9241,
	"./MySQL.png": 434,
	"./Netlify.png": 6729,
	"./NodeJS.png": 9874,
	"./NumPy.png": 8461,
	"./Pandas.png": 544,
	"./Postman.png": 2319,
	"./PyTorch.png": 2567,
	"./Python.png": 1590,
	"./R.png": 2990,
	"./React.png": 9990,
	"./SocketIO.png": 1637,
	"./Tableau.png": 9355,
	"./TensorFlow.png": 7800,
	"./ThreeJs.png": 4082,
	"./Trello.png": 2143,
	"./TypeScript.png": 8665,
	"./VisualParadigm.png": 4278,
	"./Vite.png": 3300,
	"./ggplot2.png": 4057,
	"./nn.png": 9642,
	"./sci-kit-learn.png": 5804
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2981;